import { CrudFormFooterComponent } from '@admin/components/crud-form-footer/crud-form-footer.component';
import { CrudFormHeaderComponent } from '@admin/components/crud-form-header/crud-form-header.component';
import { CrudFormComponent } from '@admin/components/crud-form/crud-form.component';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ReactiveFormsModule, FormsModule, Validators } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { AlertComponent } from '@shared/components/alert/alert.component';

@Component({
  selector: 'app-tags-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,

    AlertComponent,
    CrudFormHeaderComponent,
    CrudFormFooterComponent,
  ],
  templateUrl: './tags-form.component.html',
  styleUrl: './tags-form.component.scss',
})
export class TagsFormComponent extends CrudFormComponent {
  override data = this.formBuilder.group({
    name: ['', [Validators.required]],
    entity: ['', [Validators.required]],
    active: [true],
  });

  override handleLoadResponse(responses: any[]): void {
    if (this.dataId() !== -1 && responses[0] && responses[0].status === 200) {
      const responseData = responses[0].data;
      this.data.patchValue(responseData);
    }
  }

  override getParams() {
    const params: any = this.data.value;
    params.active = Number(params.active);

    if (this.eventId() !== -1) {
      params['event_id'] = this.eventId();
    }

    return params;
  }
}
